import { vnTemplate } from "@valnet/vnKnockoutJsTemplates/vnTemplate";
import { validationsList_template } from "@valnet/vnKnockoutJsTemplates/validationsList_template";
import { getIconSprite } from "~/utils/sprite";
export class login_template extends vnTemplate {
    static { this.ERROR_TYPE_VALIDATION = "validation"; }
    getTemplateHtml() {
        return /* html */ `
                ${this.validationsList.getHtmlBuild()}

                <div class="layout-login">
                    <div class="login-form" id="login-form" data-bind="visible: !is2FaEnabled() && !isPasswordResetVisible()">
                        <div class="login-form__header">
                            <h3 class="title">Sign in to LeadPilot</h3>
                        </div>
                        <form class="login-form__form">
                            <div class="input-group">
                                <label class="label">
                                    <span class="text-sm">Username or Email Address</span>
                                </label>
                                <div
                                    class="input"
                                    data-size="xl"
                                    data-shape="pill"
                                >
                                    <input 
                                        type="text" 
                                        class="input__element" 
                                        placeholder="Username or email"
                                        data-bind="value: u, uniqueName: true, event: { keyup: onKeyUpLoginAction}" 
                                    />
                                </div>
                            </div>
                            <div class="input-group">
                                <label class="label">
                                    <span class="text-sm">Password</span>
                                    <button 
                                        class="link text-sm login-form__forgot-link" 
                                        type="button" 
                                        data-bind="click: onClickForgotPassword"
                                        data-color="primary"
                                        data-underline="always"
                                    >
                                        Forgot your password ?
                                    </button>
                                </label>
                                <div 
                                    class="input"
                                    data-size="xl" 
                                    data-shape="pill"
                                >
                                    <input 
                                        type="password" 
                                        class="input__element" 
                                        placeholder="Password"
                                        data-bind="value: p, uniqueName: true, event: { keyup: onKeyUpLoginAction}" 
                                    />
                                </div>
                            </div>
                        </form>
                        <div class="login-form__actions">
                            <button 
                                data-bind="event: { click: onSubmitLoginForm}" 
                                type="button" 
                                class="button"
                                data-size="xl"
                                data-color="primary"
                                data-shape="pill"
                                data-block
                            >
                                <span class="button__content">
                                    Sign in
                                </span>
                            </button>
                        </div>
                    </div>

                    <div
                        class="login-form"
                        id="retrieve-password"
                        data-bind="visible: isPasswordResetVisible() && sentMessage() === 'none'"
                    >
                        <div class="login-form__header">
                            <h3 class="title">Forgot your password</h3>
                            <p class="subtitle">Enter your email or username and we'll send you a reset link.</p>
                        </div>
                        <form class="login-form__form" onsubmit="return false;">
                            <div class="input-group">
                                <span class="text-sm">Reset via</span>
                                <div class="login-form__options" role="radiogroup" aria-label="Reset via">
                                    <label
                                        class="login-form__option"
                                        data-bind="css: { 'is-selected': userInput() === '1' }"
                                    >
                                        <input
                                            type="radio"
                                            name="radioPass"
                                            id="radio_email"
                                            value="1"
                                            data-bind="checked: userInput, click: onClickRadioPasswordAction"
                                        />
                                        <span>Email</span>
                                    </label>
                                    <label
                                        class="login-form__option"
                                        data-bind="css: { 'is-selected': userInput() === '0' }"
                                    >
                                        <input
                                            type="radio"
                                            name="radioPass"
                                            id="radio_name"
                                            value="0"
                                            data-bind="checked: userInput, click: onClickRadioPasswordAction"
                                        />
                                        <span>Username</span>
                                    </label>
                                </div>
                            </div>
                            <div class="input-group">
                                <label class="label" for="retrieveInput">
                                    <span class="text-sm" data-bind="text: userInput() === '1' ? 'Email' : 'Username'"></span>
                                </label>
                                <div
                                    class="input"
                                    data-size="xl"
                                    data-shape="pill"
                                >
                                    <input
                                        id="retrieveInput"
                                        type="text"
                                        class="input__element"
                                        data-bind="value: retrieveInput, attr: { placeholder: userInput() === '1' ? 'Email address' : 'Username' }, event: { keyup: onKeyUpSentLinkAction}"
                                    />
                                </div>
                            </div>
                        </form>
                        <div class="login-form__actions">
                            <button
                                class="button"
                                data-color="primary"
                                data-size="xl"
                                data-shape="pill"
                                data-block
                                type="button"
                                data-bind="event: { click: onClickRetrievePasswordAction}"
                            >
                                <span class="button__content">Send reset link</span>
                            </button>
                            <button
                                class="link text-sm"
                                type="button"
                                data-color="primary"
                                data-underline="always"
                                data-bind="event: { click: onClickCloseRetrieveAction}"
                            >
                                <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <use href="${getIconSprite("arrow-left")}"></use>
                                </svg>
                                Back to sign in
                            </button>
                        </div>
                    </div>

                    <div
                        class="login-form"
                        data-bind="visible: isPasswordResetVisible() && sentMessage() === 'block'"
                    >
                        <div class="login-form__header">
                            <h3 class="title">Check your inbox</h3>
                            <p class="subtitle" data-bind="text: retrieveInfo"></p>
                        </div>
                        <div class="login-form__actions">
                            <button
                                class="link text-sm"
                                type="button"
                                data-color="primary"
                                data-underline="always"
                                data-bind="event: { click: onClickCloseRetrieveAction}"
                            >
                                <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <use href="${getIconSprite("arrow-left")}"></use>
                                </svg>
                                Back to sign in
                            </button>
                        </div>
                    </div>

                    <div class="login-form" id="otp-form" data-bind="visible: is2FaEnabled">
                        <div class="login-form__header">
                            <h3 class="title">Two-factor authentication</h3>
                            <p class="subtitle">
                                Your <span data-bind="text: appName"></span> account is secured with two-factor authentication.
                                A code has been sent to your email address.
                            </p>
                        </div>
                        <form class="login-form__form" onsubmit="return false;">
                            <div class="input-group">
                                <label class="label">
                                    <span class="text-sm">Enter 2FA code</span>
                                </label>
                                <div class="login-form__otp" aria-label="Two-factor authentication code">
                                    <input type="text" inputmode="numeric" maxlength="1" placeholder="·" name="otp-1" autocomplete="one-time-code"
                                        data-bind="value: otpCode1, uniqueName: true, event: { input: onOtpInput, keyup: onOtpKeyUp, paste: onOtpPaste }">
                                    <input type="text" inputmode="numeric" maxlength="1" placeholder="·" name="otp-2" autocomplete="one-time-code"
                                        data-bind="value: otpCode2, uniqueName: true, event: { input: onOtpInput, keyup: onOtpKeyUp }">
                                    <input type="text" inputmode="numeric" maxlength="1" placeholder="·" name="otp-3" autocomplete="one-time-code"
                                        data-bind="value: otpCode3, uniqueName: true, event: { input: onOtpInput, keyup: onOtpKeyUp }">
                                    <input type="text" inputmode="numeric" maxlength="1" placeholder="·" name="otp-4" autocomplete="one-time-code"
                                        data-bind="value: otpCode4, uniqueName: true, event: { input: onOtpInput, keyup: onOtpKeyUp }">
                                    <input type="text" inputmode="numeric" maxlength="1" placeholder="·" name="otp-5" autocomplete="one-time-code"
                                        data-bind="value: otpCode5, uniqueName: true, event: { input: onOtpInput, keyup: onOtpKeyUp }">
                                    <input type="text" inputmode="numeric" maxlength="1" placeholder="·" name="otp-6" autocomplete="one-time-code"
                                        data-bind="value: otpCode6, uniqueName: true, event: { input: onOtpInput, keyup: onOtpKeyUp }">
                                </div>
                            </div>
                            <div class="login-form__status">
                                <p class="login-form__hint" data-bind="visible: !isCountdownDisabled()">
                                    Code expires in <span data-bind="text: countdownTimer"></span>.
                                </p>
                                <p class="login-form__message login-form__message--success" data-bind="visible: otpSuccessMessage, text: otpSuccessMessage"></p>
                                <p class="login-form__message login-form__message--error" data-bind="visible: otpFailureMessage, text: otpFailureMessage"></p>
                            </div>
                        </form>
                        <div class="login-form__actions">
                            <button
                                type="button"
                                class="button"
                                data-color="primary"
                                data-size="xl"
                                data-shape="pill"
                                data-block
                                data-bind="event: { click: onSubmitOtpForm }, enable: !is2FaVerifyDisabled()"
                            >
                                <span class="button__content">Verify</span>
                            </button>
                            <button
                                type="button"
                                class="link text-sm"
                                data-underline="hover"
                                data-bind="event: { click: onResendOtpCode }, enable: !isResendDisabled()"
                            >
                                Resend code
                            </button>
                            <button
                                type="button"
                                class="link text-sm"
                                data-color="primary"
                                data-underline="always"
                                data-bind="event: { click: onClickCloseRetrieveAction}"
                            >
                                <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <use href="${getIconSprite("arrow-left")}"></use>
                                </svg>
                                Back to sign in
                            </button>
                        </div>
                    </div>
                </div>
            `;
    }
    initPartial() {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        const currentHost = this.getTemplateViewModel().currentHost();
        if (currentHost.includes("emakicms.com")) {
            this.getTemplateViewModel().appName("Emaki");
        }
        else if (currentHost.includes("adsninja.ca")) {
            this.getTemplateViewModel().appName("Ads Ninja");
        }
        else if (currentHost.includes("pubinsights.com")) {
            this.getTemplateViewModel().appName("Pub Insights");
        }
    }
    getTemplateName() {
        return "login-form-template";
    }
    getMainElementClasses() {
        return ["w-full", "h-full"];
    }
    buildViewModel() {
        let huit_neuf_this = this;
        function padNumber(num) {
            return num < 10 ? "0" + num : num.toString();
        }
        let viewModel = {
            u: "",
            p: "",
            retrieveInput: ko.observable(""),
            retrieveInfo: ko.observable(""),
            userInput: ko.observable("1"),
            sentMessage: ko.observable("none"),
            isPasswordResetVisible: ko.observable(false),
            currentHost: ko.observable(window.location.host),
            maintTimerText: ko.observable("Loading..."),
            isMaintenanceMessageVisible: ko.observable(true),
            isEmakiHost: ko.pureComputed(function () {
                const hostPattern = /^(emakicms\.com(\.[a-zA-Z0-9_-]+)?|ads\.emakicms\.com|qa\d+\.emakicms\.com|mig\d+\.emakicms\.com)$/;
                return hostPattern.test(huit_neuf_this.buildViewModel().currentHost());
            }),
            startMaintenanceCountdown() {
                const maintenanceTimeUTC = new Date(Date.UTC(2025, 7, 12, 21, 45, 0));
                const updateCountdown = () => {
                    const now = new Date();
                    const diff = maintenanceTimeUTC.getTime() - now.getTime();
                    if (diff <= 0) {
                        this.maintTimerText("Maintenance in progress or completed.");
                        clearInterval(timerInterval);
                        this.isMaintenanceMessageVisible(false);
                        return;
                    }
                    const hours = Math.floor(diff / (1000 * 60 * 60));
                    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
                    const formattedTime = `${padNumber(hours)}h ${padNumber(minutes)}m ${padNumber(seconds)}s`;
                    this.maintTimerText(formattedTime);
                };
                updateCountdown();
                const timerInterval = setInterval(updateCountdown, 1000);
            },
            appName: ko.observable("Valnet Inc"),
            is2FaEnabled: ko.observable(false),
            userId: ko.observable(""),
            dateTwoFactorExpires: ko.observable(""),
            otpCode1: ko.observable(""),
            otpCode2: ko.observable(""),
            otpCode3: ko.observable(""),
            otpCode4: ko.observable(""),
            otpCode5: ko.observable(""),
            otpCode6: ko.observable(""),
            countdownTimer: ko.observable("00:00"),
            is2FaVerifyDisabled: ko.observable(false),
            countdownInterval: null,
            isResendDisabled: ko.observable(false),
            isCountdownDisabled: ko.observable(false),
            otpSuccessMessage: ko.observable(""),
            otpFailureMessage: ko.observable(""),
            onKeyUpLoginAction: this.onKeyUpLoginAction,
            onKeyUpSentLinkAction: function (data, event) {
                huit_neuf_this.onKeyUpSentLinkAction(data, event);
            },
            onClickForgotPassword: function () {
                huit_neuf_this.showPasswordResetForm();
            },
            onClickRetrievePasswordAction: function () {
                huit_neuf_this.onClickRetrievePasswordAction();
            },
            onClickRadioPasswordAction: this.onClickRadioPasswordAction,
            onClickCloseRetrieveAction: function () {
                huit_neuf_this.onRedirectToLogin();
            },
            onSubmitLoginForm: function () {
                huit_neuf_this.caller.onSubmitLoginForm();
            },
            onSubmitOtpForm: function () {
                huit_neuf_this.caller.onSubmitOtpForm();
            },
            onResendOtpCode: function () {
                huit_neuf_this.caller.onResendOtpCode();
            },
            startCountdown() {
                if (!this.dateTwoFactorExpires() || this.dateTwoFactorExpires() === "") {
                    this.countdownTimer("Expired");
                    return;
                }
                let expirationTimeET = new Date(this.dateTwoFactorExpires());
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
                this.countdownInterval = setInterval(() => {
                    let now = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
                    let timeDiff = expirationTimeET.getTime() - now.getTime();
                    if (timeDiff <= 0) {
                        clearInterval(this.countdownInterval);
                        this.countdownTimer("Expired");
                        return;
                    }
                    let minutes = Math.floor(timeDiff / 60000);
                    let seconds = Math.floor((timeDiff % 60000) / 1000);
                    let formattedSeconds = seconds < 10 ? "0" + seconds.toString() : seconds.toString();
                    this.countdownTimer(`${minutes}:${formattedSeconds}`);
                }, 1000);
            },
            onOtpPaste: function (data, event) {
                const pastedData = event.clipboardData.getData("text") || "";
                if (pastedData.length === 6 && /^\d+$/.test(pastedData)) {
                    const inputs = event.target.parentElement.querySelectorAll("input");
                    pastedData.split("").forEach((char, index) => {
                        if (inputs[index]) {
                            inputs[index].value = char;
                            data[`otpCode${index + 1}`](char);
                        }
                    });
                    setTimeout(() => {
                        let otpCode = data.getFullOtpCode();
                        if (otpCode.length === 6 && /^\d+$/.test(otpCode)) {
                            data.onSubmitOtpForm();
                        }
                    }, 0);
                    event.preventDefault();
                }
            },
            onOtpInput: function (data, event) {
                const input = event.target;
                const key = event.inputType || event.key;
                if (key === "deleteContentBackward" || key === "Backspace") {
                    if (input.value.length === 0) {
                        let prevInput = input.previousElementSibling;
                        if (prevInput && prevInput.tagName === "INPUT") {
                            prevInput.focus();
                        }
                    }
                }
                else if (input.value.length === 1) {
                    let nextInput = input.nextElementSibling;
                    if (nextInput && nextInput.tagName === "INPUT") {
                        nextInput.focus();
                    }
                }
            },
            onOtpKeyUp: function (data, event) {
                const fullOtpCode = data.getFullOtpCode();
                if (event.key === "Enter" && fullOtpCode.length === 6 && !data.is2FaVerifyDisabled()) {
                    data.onSubmitOtpForm();
                }
            },
            getFullOtpCode: function () {
                return `${viewModel.otpCode1()}${viewModel.otpCode2()}${viewModel.otpCode3()}${viewModel.otpCode4()}${viewModel.otpCode5()}${viewModel.otpCode6()}`;
            },
        };
        viewModel.is2FaEnabled.subscribe(function (newValue) {
            if (newValue) {
                viewModel.startCountdown();
            }
        });
        viewModel.dateTwoFactorExpires.subscribe(function (newValue) {
            if (newValue) {
                viewModel.startCountdown();
            }
        });
        return viewModel;
    }
    onKeyUpLoginAction(data, event) {
        event.preventDefault();
        if (event.keyCode == 13) {
            data.onSubmitLoginForm();
        }
    }
    onKeyUpSentLinkAction(data, event) {
        event.preventDefault();
        if (event.keyCode == 13) {
            this.caller.retrievePassword();
        }
        return false;
    }
    showPasswordResetForm() {
        this.getTemplateViewModel().sentMessage("none");
        this.getTemplateViewModel().retrieveInput("");
        this.getTemplateViewModel().isPasswordResetVisible(true);
    }
    onClickRetrievePasswordAction() {
        this.caller.retrievePassword();
    }
    onClickRadioPasswordAction(data) {
        data.retrieveInput("");
        return true;
    }
    onRedirectToLogin() {
        this.caller.redirectToLogin();
    }
    setError(error) {
        this.validationsList.setMessageUsingDefaultFormat(error);
        window.scrollTo(0, 0);
    }
    clearValidationsMessages() {
        this.validationsList.clearMessages();
    }
    enableTwoFactorVerification(is2FaNeeded, userId, dateTwoFactorExpires) {
        this.getTemplateViewModel().userId(userId);
        this.getTemplateViewModel().dateTwoFactorExpires(dateTwoFactorExpires);
        this.getTemplateViewModel().is2FaEnabled(is2FaNeeded);
    }
    onSubmitOtpForm() {
        this.caller.onSubmitOtpForm();
    }
    onResendOtpCode() {
        this.caller.onResendOtpCode();
    }
    disableVerify(isDisabled) {
        if (this.getTemplateViewModel().countdownInterval) {
            clearInterval(this.getTemplateViewModel().countdownInterval);
            this.getTemplateViewModel().countdownInterval = null;
        }
        this.getTemplateViewModel().dateTwoFactorExpires("");
        this.getTemplateViewModel().is2FaVerifyDisabled(isDisabled);
        this.getTemplateViewModel().countdownTimer("Expired");
    }
    setIsResendDisabled(isResendDisabled) {
        this.getTemplateViewModel().isResendDisabled(isResendDisabled);
    }
    setIs2FaVerifyDisabled(is2FaVerifyDisabled) {
        this.getTemplateViewModel().is2FaVerifyDisabled(is2FaVerifyDisabled);
    }
    setDateTwoFactorExpires(dateTwoFactorExpires) {
        this.getTemplateViewModel().dateTwoFactorExpires(dateTwoFactorExpires);
    }
    setIsCountdownDisabled(isCountDownDisabled) {
        this.getTemplateViewModel().isCountdownDisabled(isCountDownDisabled);
    }
}
